/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WorkingTimeCosts } from './WorkingTimeCosts';
import {
    WorkingTimeCostsFromJSON,
    WorkingTimeCostsFromJSONTyped,
    WorkingTimeCostsToJSON,
    WorkingTimeCostsToJSONTyped,
} from './WorkingTimeCosts';

/**
 * 
 * @export
 * @interface BulkCalculateWorkingTimeCostResponse
 */
export interface BulkCalculateWorkingTimeCostResponse {
    /**
     * 
     * @type {WorkingTimeCosts}
     * @memberof BulkCalculateWorkingTimeCostResponse
     */
    data: WorkingTimeCosts;
}

/**
 * Check if a given object implements the BulkCalculateWorkingTimeCostResponse interface.
 */
export function instanceOfBulkCalculateWorkingTimeCostResponse(value: object): value is BulkCalculateWorkingTimeCostResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function BulkCalculateWorkingTimeCostResponseFromJSON(json: any): BulkCalculateWorkingTimeCostResponse {
    return BulkCalculateWorkingTimeCostResponseFromJSONTyped(json, false);
}

export function BulkCalculateWorkingTimeCostResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkCalculateWorkingTimeCostResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': WorkingTimeCostsFromJSON(json['data']),
    };
}

  export function BulkCalculateWorkingTimeCostResponseToJSON(json: any): BulkCalculateWorkingTimeCostResponse {
      return BulkCalculateWorkingTimeCostResponseToJSONTyped(json, false);
  }

  export function BulkCalculateWorkingTimeCostResponseToJSONTyped(value?: BulkCalculateWorkingTimeCostResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': WorkingTimeCostsToJSON(value['data']),
    };
}

